import * as z from 'zod';

import { AuditBackgroundFormSchema } from './audit-background-form';
import { AuditChecklistFormSchema } from './audit-checklist-form';
import { AuditMechanicalFormSchema } from './audit-mechanical-form';
import { type AuditId } from './audit';

export const AuditFormSchema = z.discriminatedUnion('type', [
  AuditBackgroundFormSchema,
  AuditChecklistFormSchema,
  AuditMechanicalFormSchema,
]);

export type AuditForm = z.infer<typeof AuditFormSchema>;
export type AuditFormType = AuditForm['type'];

export class AuditFormNotFoundError extends Error {
  constructor(auditId: AuditId, formType: AuditFormType) {
    super(
      `Audit form of type "${formType}" for audit with ID "${auditId}" not found`,
    );
    this.name = 'AuditFormNotFoundError';
  }
}
